import { Checkbox, TextField } from 'material-ui';
import React, { useState } from 'react';
import ClientButtons from '../client-buttons/ClientButtons';
import { DatePicker , MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns'
import './table-item.scss'
import { dateCompare, formatDate, generateAppDate } from 'utils/utils';
import { updateClientInfo } from 'service/api';
import { useDispatch } from 'react-redux';
import { fetchCounsellors, fetchUpdatedCounsellor } from 'modules/admin/redux/actions';


const TableItem = ({client, isDirect, isICBC, isDeactivated}) => {
    const {firstName, lastName, approvedSessions, usedSessions, totalBilled, expiryDate, alert, chargedSessions, partialPaid, counsellor, isActive, mutationRequest, id, dateOfApprovalCheck} = client
    const [changedExpDate, setDate] = useState(expiryDate ? formatDate(new Date(expiryDate)) : null)
    const [approved, setApproved] = useState(approvedSessions)
    const [loading, setLoading] = useState(false)
    const [checkboxDisabled, setCheckboxDisabled] = useState(false)
    const [activateLoading, setActivateLoading] = useState(false)
    const dispatch = useDispatch()

    const inputHandler = (e) => {
        setApproved(e.target.value)
    }

    const dateInputHandler = (date) => {
        const updatedDate = formatDate(date)

        setDate(updatedDate)
    }
    
    const saveHandler = async () => {
        try {
            const requestData = {
                id,
                expiryDate: changedExpDate,
                approvedSessions: +approved
            }

            if (dateCompare(changedExpDate, expiryDate) || approvedSessions < approved) {
                requestData.approvalStatus = false
            }
            
            setLoading(true)
            await updateClientInfo(requestData)
            await dispatch(fetchUpdatedCounsellor(counsellor.acuityID))
        } catch(e) {
            console.log(e)
        } finally {
            setLoading(false)
        }
    }

    const checkboxHandler = async () => {
        try {
            const requestData = {
                id,
                approvalStatus: !dateOfApprovalCheck
            }

            setCheckboxDisabled(true)
            await updateClientInfo(requestData)
            await dispatch(fetchUpdatedCounsellor(counsellor.acuityID))
        } catch(e) {
            console.log(e)
        } finally {
            setCheckboxDisabled(false)
        }
    }

    const activateHandler = async () => {
        try {
            const requestData = {
                isActive: !isActive,
                mutationRequest: false,
                id
            }

            setActivateLoading(true)
            await updateClientInfo(requestData)
            await dispatch(fetchUpdatedCounsellor(counsellor.acuityID))
        } catch(e) {
            console.log(e)
        } finally {
            setActivateLoading(false)
        }
    }

    const showCheckbox = isICBC || (isDirect && !isDeactivated)
    const isBtnDisabled = (+approved === approvedSessions && expiryDate === changedExpDate) || loading
    return (
        <section className="invoice-line-item-container">
            <article 
                className={`invoice-line-item client-tale-item ${alert || ""}`}
            >
                <span className="flex-20 cell" style={{flex: "10% 1"}}>{firstName} {lastName}</span>
                <span className="flex-20 cell" style={{flex: "10% 1"}}>
                    {
                        isDirect 
                            ? <TextField 
                                value={approved}
                                onChange={inputHandler}
                                className="approved-input"
                                type='number'
                              />
                            : chargedSessions
                    }

                    {
                        partialPaid 
                            ? ` (${partialPaid})` 
                            : ''
                    }

                    {
                        showCheckbox &&
                        <>
                            <Checkbox
                                color='default'
                                className='approved-checkbox'
                                checked={!!dateOfApprovalCheck}
                                onClick={checkboxHandler}
                                disabled={checkboxDisabled}
                            />
                            {
                                dateOfApprovalCheck &&
                                <span className='approval-date'>
                                    ({generateAppDate(dateOfApprovalCheck)})
                                </span>
                                    
                            }
                        </>
                    }
                </span>
                <span className="flex-20 cell" style={{flex: "10% 1"}}>{usedSessions}</span>
                {   isDirect && 
                    <>
                        <span className="flex-20 cell" style={{flex: "10% 1"}}>{totalBilled}</span>
                        {
                            isICBC &&
                            <span className="flex-20 cell" style={{flex: "12% 1"}}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker
                                        format="MMM dd, yyyy"
                                        value={changedExpDate}
                                        onChange={dateInputHandler}
                                        className="date-input"
                                    />
                                </MuiPickersUtilsProvider>
                                
                            </span>
                        }
                    </>
                }
                <span className={`flex-20 cell buttons-col ${!isDirect ? "non-direct-btn" : ""}`}  style={{flex: "13% 1"}}>
                    <ClientButtons 
                        isDeactivated={isDeactivated} 
                        isDirect={isDirect}
                        disableSaveBtn={isBtnDisabled}
                        saveHandler={saveHandler}
                        activateHandler={activateHandler}
                        saveLoading={loading}
                        activateLoading={activateLoading}
                        mutationRequest={mutationRequest}
                    />
                </span>
            </article>
        </section>
    );
};

export default TableItem;